import React, { useCallback, useEffect, useState } from "react";

import apiClient from "../../../services/apiClient";
import { openMonthlySummary } from "../../academy/components/monthlySummaryOpen";
import "./MonthlySummaryMonitor.css";

// 운영자용 학원별 월간 결산. 한 달에 한 번 전 학원을 훑고, 쪼을 곳을 고른다.
//
// 학원 이름을 누르면 그 학원이 받는 화면이 그대로 새 탭에 열린다. 우리가 보는 것과
// 학원이 받는 것이 같아야 무엇을 보냈는지 헷갈리지 않는다.
const MonthlySummaryMonitor = () => {
  const [month, setMonth] = useState("");
  const [paidOnly, setPaidOnly] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const load = useCallback(async (targetMonth, onlyPaid) => {
    setLoading(true);
    setError("");
    try {
      const response = await apiClient.get("/api/v1/echo/admin/monthly-summary", {
        params: {
          ...(targetMonth ? { month: targetMonth } : {}),
          paid: onlyPaid ? 1 : 0,
        },
        withAuth: true,
      });
      setData(response.data);
      setMonth(response.data.month);
    } catch (e) {
      setError("결산을 불러오지 못했습니다.");
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    load("", true);
  }, [load]);

  const rows = data?.rows ?? [];

  return (
    <div className="ms-wrap">
      <div className="ms-head">
        <h3 className="section-title">학원별 월간 결산</h3>
        <select
          className="ms-month"
          value={month}
          onChange={(event) => load(event.target.value, paidOnly)}
        >
          {(data?.month_choice_list ?? []).map((choice) => (
            <option key={choice} value={choice}>
              {choice}
            </option>
          ))}
        </select>
        <button
          type="button"
          className={`ms-toggle${paidOnly ? " on" : ""}`}
          onClick={() => {
            const next = !paidOnly;
            setPaidOnly(next);
            load(month, next);
          }}
        >
          {paidOnly ? "유료 학원만" : "전체 학원"}
        </button>
        {loading && <span className="ms-hint">불러오는 중...</span>}
        {!loading && <span className="ms-hint">{rows.length}곳</span>}
      </div>

      <p className="ms-hint ms-desc">
        학원 이름을 누르면 그 학원이 보는 결산이 새 탭에 열립니다. 결산은 로그인한
        사람만 볼 수 있고, 학원은 교사 화면의 팝업과 학원관리 탭에서 직접 엽니다.
      </p>

      {error && <p className="ms-error">{error}</p>}

      <div className="ms-scroll">
        <table className="ms-table">
          <thead>
            <tr>
              <th>학원</th>
              <th>낸 과제</th>
              <th>완료율</th>
              <th>평균</th>
              <th>지난달</th>
              <th>아이</th>
              <th>재출제</th>
              <th>레테</th>
              <th>안 푼 아이</th>
              <th>안 쓴 기능</th>
              <th>사다리</th>
              <th>결산</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.user_id}>
                <td className="ms-name">
                  <button
                    type="button"
                    className="ms-link"
                    onClick={() =>
                      openMonthlySummary({
                        month,
                        userId: row.user_id,
                        title: row.academy,
                      })
                    }
                  >
                    {row.academy}
                  </button>
                  <span className="ms-nick">{row.nickname}</span>
                </td>
                <td className="ms-num ms-strong">{row.given.toLocaleString()}</td>
                <td className="ms-num">{row.finished_rate}%</td>
                <td className="ms-num">{row.average ?? "-"}</td>
                <td className="ms-num">
                  {row.change === null || row.change === undefined ? (
                    "-"
                  ) : (
                    <span className={row.change >= 0 ? "ms-up" : "ms-down"}>
                      {row.change > 0 ? `+${row.change}` : row.change}
                    </span>
                  )}
                </td>
                <td className="ms-num">
                  {row.student_count}/{row.registered_count}
                </td>
                <td className={`ms-num${row.retry_rate < 50 ? " ms-down" : ""}`}>
                  {row.retry_rate}%
                </td>
                <td className="ms-num">
                  {row.leveltest_count === null ? "-" : `${row.leveltest_count}회`}
                </td>
                <td className={`ms-num${row.never_started_count ? " ms-down" : ""}`}>
                  {row.never_started_count}명
                </td>
                <td className="ms-small">
                  {row.unused_name_list.length
                    ? row.unused_name_list.join(", ")
                    : "다 씀"}
                </td>
                <td className="ms-num">{row.ladder_done}/5</td>
                <td className="ms-actions">
                  <button
                    type="button"
                    className="ms-open"
                    onClick={() =>
                      openMonthlySummary({
                        month,
                        userId: row.user_id,
                        title: row.academy,
                      })
                    }
                  >
                    리포트 열기
                  </button>
                  {row.opened && <span className="ms-seen">열어봄</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MonthlySummaryMonitor;
